import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const chartData = [
  { label: "Staf teknik", staff: 41, salary: 42 },
  { label: "Staf i shërbimeve të brendshme", staff: 33, salary: 25 },
  { label: "Staf i administratës", staff: 15, salary: 13 },
  { label: "Staf drejtues", staff: 5, salary: 14 },
  { label: "Programacion", staff: 6, salary: 7 },
];

const HorizontalBarChart = ({ dataChart }) => {
  // const [stateDataChart, setStateDataChart] = React.useState(
  //   dataChart ? dataChart : chartData
  // );
  const stateDataChart = dataChart
    ? Array.isArray(dataChart)
      ? dataChart
      : chartData
    : chartData;

  const labels = stateDataChart.map((d) => d.label);

  const staffData = stateDataChart.map((d) => d.staff);
  const salaryData = stateDataChart.map((d) => d.salary);

  const data = {
    labels,
    datasets: [
      {
        label: "% e ndarjes së stafit sipas profesionit",
        data: staffData,
        backgroundColor: "#EC2100",
        barThickness: 20,
        datalabels: {
          color: "white",
        },
      },
      {
        label: "% sipas totalit të pagave janar",
        data: salaryData,
        backgroundColor: "#f4bcbc",
        barThickness: 20,
        datalabels: {
          color: "#000",
        },
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          color: "#333",
          font: {
            size: 14,
          },
        },
      },
      datalabels: {
        anchor: "center",
        align: "center",
        formatter: (value) => `${value}%`,
        font: {
          size: 14,
          weight: "bold",
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        max: 100,
        ticks: {
          color: "#333",
          callback: (value) => `${value}%`,
          font: {
            size: 12,
          },
        },
        grid: {
          color: "#e0e0e0",
        },
      },
      y: {
        stacked: true,
        ticks: {
          color: "#333",
          font: {
            size: 14,
          },
        },
        grid: {
          display: false,
        },
      },
    },
  };

  return <Bar options={options} data={data} />;
};

export default HorizontalBarChart;
